export const generateOrderId = () => {
    const timestamp = Date.now().toString(36); // Convert current time to base-36 string
    const randomString = Math.random().toString(36).substring(2, 8); // Random 6-character string
    return `ORDER-${timestamp}-${randomString}`.toUpperCase();
};

export const calculateDeliveryDate = (businessDays = 5) => {
    const date = new Date();
    let addedDays = 0;
  
    while (addedDays < businessDays) {
      date.setDate(date.getDate() + 1); // Add one day
      if (date.getDay() !== 0 && date.getDay() !== 6) { // Skip weekends (0 = Sunday, 6 = Saturday)
        addedDays++;
      }
    }
  
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };